export default class {
	constructor($state) {
        'ngInject';
        
        this._$state = $state;
        
		return {
			STATUS: {
				ADD: 0,
				UPDATE: 1,
				DELETE: 2,
				STATIC: -1
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/Constants.js